import React, { useState, useEffect } from "react";
import axios from "axios";
import { message, Modal, Spin } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
import { FormOutlined } from "@ant-design/icons";
import SummaryApi from "../../../common";
import "../../../Styles/SellerStylings/ProductList.css";

const AdminProductList = ({ sellerId, setActiveTab, setEditProduct ,onEdit,refresh}) => {
  const [products, setProducts] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [loading, setLoading] = useState(true);

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const defaultImage = "/images/default_product.jpg";
  const token = localStorage.getItem("adminToken");

  // Fetch products for this seller
  const fetchProducts = async () => {
    if (!sellerId) return;
    setLoading(true);
    try {
    

      const res = await axios.get(SummaryApi.getSellerProducts(sellerId).url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(res.data.success ? res.data.data || [] : []);
        console.log("PRODUCTS FROM BACKEND:", res.data.data);
    } catch (err) {
      console.error("Error fetching products:", err);
      message.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  // Delete product
  const handleDelete = async (productId) => {
  try {
    const res = await axios({
      ...SummaryApi.deleteProductByAdmin(productId),
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data.success) {
      message.success("Product deleted successfully");
      fetchProducts(); // Refresh list
    } else {
      message.error("Failed to delete product");
    }
  } catch (err) {
    console.error("Error deleting product:", err.response?.data || err.message);
    message.error("Failed to delete product");
  }
};


  // Image preview
  const handleImageClick = (imgSrc) => {
    setPreviewImage(imgSrc || defaultImage);
    setPreviewVisible(true);
  };

  useEffect(() => {
    fetchProducts();
  }, [sellerId,refresh]);

  if (loading) return <Spin size="large" style={{ display: "block", margin: "50px auto" }} />;
  const handleEdit = (product) => {
  setEditProduct(product); 
    console.log("EDIT PRODUCT:", product);     // store selected product
  setActiveTab("upload-product"); // switch tab to upload form
};
  return (
    <div>
      <h2>Products of Seller</h2>
      <div className="product-grid">
        {products.map((p) => {
 // ---------------- SAFE IMAGE HANDLING ----------------
let imagePath = "";

// Case 1: images is an array
if (Array.isArray(p.images) && p.images.length > 0) {
  // If the first element is itself an array, take its first item
  imagePath = Array.isArray(p.images[0]) ? p.images[0][0] : p.images[0];
}

// Case 2: images is a string
else if (typeof p.images === "string") {
  try {
    const parsed = JSON.parse(p.images);
    imagePath = Array.isArray(parsed) ? (Array.isArray(parsed[0]) ? parsed[0][0] : parsed[0]) : parsed;
  } catch {
    imagePath = p.images;
  }
}

// If invalid or empty, fallback to default
if (!imagePath) {
  imagePath = defaultImage;
}

// Build final image URL
let imageSrc = imagePath.startsWith("/uploads") ? `${BASE_URL}${imagePath}` : imagePath === defaultImage ? defaultImage : `${BASE_URL}/${imagePath}`;


;

          return (
            <div className="product-card" key={p.id}>
              <div className="image-wrapper" onClick={() => handleImageClick(imageSrc)}>
                <img
                  src={imageSrc}
                  alt={p.name}
                  className="product-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{p.name}</h3>
                <p className="product-category">{p.category_name}</p>
                <div className="price-row">
                  <span className="selling-price">₹{p.selling_price}</span>
                  <span className="actual-price">₹{p.actual_price}</span>
                </div>
                <div className="stock-delivery">
                  <span className="product-stock">Stock: {p.stock}</span>
                  <span className="product-delivery">
                    {p.deliveryOption === "store_pickup"
                      ? "Store Pickup"
                      : p.deliveryOption === "home_delivery"
                      ? "Home Delivery"
                      : "Both"}
                  </span>
                </div>
                 <div className="action-icons">
                <FormOutlined style={{fontSize:"20px" ,color:"#1129ce"}} onClick={() => handleEdit(p)}/>
                <DeleteOutlined style={{fontSize:"20px" ,color:"#ee152d"}} onClick={() => handleDelete(p.id)} />
                  </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Image Preview Modal */}
      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img
          alt="Product Preview"
          style={{ width: "100%", borderRadius: "8px" }}
          src={previewImage || defaultImage}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = defaultImage;
          }}
        />
      </Modal>
    </div>
  );
};

export default AdminProductList;